import React from 'react';

export const AdultsOnlyBdsmIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12.0799 37.64L7.35994 26.54C6.61994 24.8 6.73994 22.8 7.67994 21.16L12.3799 12.98C13.1599 11.64 14.8599 11.16 16.2199 11.92C17.5799 12.68 18.0799 14.38 17.3399 15.74L13.8999 22.2C13.3999 23.12 13.3999 24.24 13.8799 25.18L19.2199 35.56"
        fill="#EBA352"
      />
      <path
        d="M9.44005 34.5999L4.72005 23.4999C3.98005 21.7599 4.10005 19.7599 5.04005 18.1199L9.74005 9.93994C10.5201 8.59994 12.2201 8.11994 13.5801 8.87994C14.9401 9.63994 15.4401 11.3399 14.7001 12.6999L11.2601 19.1599C10.7601 20.0799 10.7601 21.1999 11.2401 22.1399L16.5801 32.5199L17.9201 30.9199L16.5601 25.0799C16 23.8599 16.5001 22.4199 17.7001 21.8199C18.9201 21.2199 20.4 21.6999 21.0201 22.9199L24.42 29.6599C25.24 31.2799 25.3001 33.1799 24.6 34.8599L20.24 45.2399H8.80005L9.76005 42.3599C10.6201 39.8199 10.5001 37.0399 9.46005 34.5599L9.44005 34.5999Z"
        fill="#FFDD67"
      />
      <path
        d="M24.6 34.88L20.22 45.28H18.92L23.68 34.32C24.4 32.64 24.32 30.74 23.5 29.12L20.12 22.3799C19.98 22.1399 19.82 21.9 19.62 21.7C20.2 21.92 20.72 22.36 21 22.94L24.4 29.68C25.22 31.32 25.3 33.22 24.58 34.88H24.6Z"
        fill="#EBA352"
      />
      <path
        d="M23.68 34.32L18.92 45.28H8.77999L9.73999 42.38C10.6 39.84 10.48 37.06 9.41999 34.6L4.69999 23.48C3.95999 21.76 4.07999 19.76 5.03999 18.12L9.71999 9.94C10.44 8.72 11.92 8.22 13.18 8.68C13.32 8.72 13.44 8.8 13.58 8.86C14.5 9.38 15.04 10.36 15.04 11.34C15.04 11.82 14.92 12.26 14.7 12.68L11.24 19.14C10.74 20.08 10.74 21.2 11.22 22.12L16.04 31.46L16.58 32.5L17.9 30.9L16.54 25.08C15.98 23.84 16.5 22.42 17.68 21.8C18.04 21.62 18.42 21.54 18.78 21.54C19.08 21.54 19.34 21.58 19.6 21.68C19.8 21.88 19.96 22.1 20.1 22.36L23.48 29.1C24.3 30.72 24.38 32.62 23.66 34.3L23.68 34.32Z"
        fill="#FFDD67"
      />
      <path
        d="M22.24 47.3601V49.96C22.24 50.84 21.54 51.5201 20.7 51.5201H6.79999C5.93999 51.5201 5.23999 50.82 5.23999 49.96V47.3601C5.23999 46.4801 5.95999 45.8 6.79999 45.8H20.7C21.56 45.8 22.24 46.5001 22.24 47.3601Z"
        fill="#ADADAD"
      />
      <path
        d="M21.24 47.3601V49.96C21.24 50.84 20.54 51.5201 19.7 51.5201H6.79999C5.93999 51.5201 5.23999 50.82 5.23999 49.96V47.3601C5.23999 46.4801 5.95999 45.8 6.79999 45.8H19.68C20.54 45.8 21.22 46.5001 21.22 47.3601H21.24Z"
        fill="#D0D0D0"
      />
      <path d="M17.08 53.84H6.28003L7.00003 51.54H17.8L17.08 53.84Z" fill="#42ADE2" />
      <path
        d="M52.02 37.64L56.74 26.54C57.48 24.8 57.36 22.8 56.42 21.16L51.72 12.98C50.94 11.64 49.24 11.16 47.88 11.92C46.52 12.68 46.02 14.38 46.76 15.74L50.2 22.2C50.7 23.12 50.7 24.24 50.22 25.18L44.88 35.56"
        fill="#EBA352"
      />
      <path
        d="M54.66 34.5999L59.38 23.4999C60.12 21.7599 60 19.7599 59.06 18.1199L54.36 9.93994C53.58 8.59994 51.88 8.11994 50.52 8.87994C49.16 9.63994 48.66 11.3399 49.4 12.6999L52.84 19.1599C53.34 20.0799 53.34 21.1999 52.86 22.1399L47.52 32.5199L46.18 30.9199L47.54 25.0799C48.1 23.8599 47.6 22.4199 46.4 21.8199C45.18 21.2199 43.7 21.6999 43.08 22.9199L39.68 29.6599C38.86 31.2799 38.8 33.1799 39.5 34.8599L43.86 45.2399H55.3L54.34 42.3599C53.48 39.8199 53.6 37.0399 54.64 34.5599L54.66 34.5999Z"
        fill="#EBA352"
      />
      <path
        d="M40.42 34.32L45.18 45.28H55.32L54.36 42.38C53.5 39.84 53.62 37.06 54.68 34.6L59.4 23.48C60.14 21.76 60.02 19.76 59.06 18.12L54.38 9.94C53.66 8.72 52.18 8.22 50.92 8.68C50.78 8.72 50.66 8.8 50.52 8.86C49.6 9.38 49.06 10.36 49.06 11.34C49.06 11.82 49.18 12.26 49.4 12.68L52.86 19.14C53.36 20.08 53.36 21.2 52.88 22.12L48.06 31.46L47.52 32.5L46.2 30.9L47.56 25.08C48.12 23.84 47.6 22.42 46.42 21.8C46.06 21.62 45.68 21.54 45.32 21.54C45.02 21.54 44.76 21.58 44.5 21.68C44.3 21.88 44.14 22.1 44 22.36L40.62 29.1C39.8 30.72 39.72 32.62 40.44 34.3L40.42 34.32Z"
        fill="#FFDD67"
      />
      <path
        d="M41.86 47.3601V49.96C41.86 50.84 42.56 51.5201 43.4 51.5201H57.3C58.16 51.5201 58.86 50.82 58.86 49.96V47.3601C58.86 46.4801 58.14 45.8 57.3 45.8H43.4C42.54 45.8 41.86 46.5001 41.86 47.3601Z"
        fill="#ADADAD"
      />
      <path
        d="M42.86 47.3601V49.96C42.86 50.84 43.56 51.5201 44.4 51.5201H57.28C58.14 51.5201 58.84 50.82 58.84 49.96V47.3601C58.84 46.4801 58.12 45.8 57.28 45.8H44.4C43.54 45.8 42.86 46.5001 42.86 47.3601Z"
        fill="#D0D0D0"
      />
      <path d="M47.02 53.84H57.8L56.92 51.54H46.14L47.02 53.84Z" fill="#42ADE2" />
      <path d="M37.36 48.6799H41.86" stroke="#858585" strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M22.24 48.6799H26.36" stroke="#858585" strokeWidth="0.5" strokeMiterlimit="10" />
      <path
        d="M28.46 47.6799H26.9C26.6018 47.6799 26.36 47.9217 26.36 48.2199V49.1199C26.36 49.4182 26.6018 49.6599 26.9 49.6599H28.46C28.7582 49.6599 29 49.4182 29 49.1199V48.2199C29 47.9217 28.7582 47.6799 28.46 47.6799Z"
        stroke="#858585"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M32.64 47.6799H31.08C30.7818 47.6799 30.54 47.9217 30.54 48.2199V49.1199C30.54 49.4182 30.7818 49.6599 31.08 49.6599H32.64C32.9383 49.6599 33.18 49.4182 33.18 49.1199V48.2199C33.18 47.9217 32.9383 47.6799 32.64 47.6799Z"
        stroke="#858585"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M36.82 47.6799H35.26C34.9617 47.6799 34.72 47.9217 34.72 48.2199V49.1199C34.72 49.4182 34.9617 49.6599 35.26 49.6599H36.82C37.1182 49.6599 37.36 49.4182 37.36 49.1199V48.2199C37.36 47.9217 37.1182 47.6799 36.82 47.6799Z"
        stroke="#858585"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path d="M29 48.6799H30.54" stroke="#858585" strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M33.1801 48.6799H34.7201" stroke="#858585" strokeWidth="0.5" strokeMiterlimit="10" />
    </svg>
  );
};
